const STORAGE_KEY = 'D11_DETAIL_DATA_V1'

export function loadDetailCache() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function saveDetailCache(data) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        data,
        savedAt: Date.now(),
      })
    )
  } catch (e) {
    // ignore
  }
}

export function clearDetailCache() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}

